<template>
  <v-content class="client feedback-requests page">
    <v-progress-linear
      v-show="!ready"
      indeterminate
      :color="themes.client.light.input"
      height="5"
      class="ma-0"
    />
    <!-- TODO: Fetch user and only show list data once user is fetched - otherwise no list data -->
    <v-container>
      <FeedbackRequestsListData
        :responders="[user]"
        @ready="loading.feedbackRequests = false"
      >
        <div slot-scope="{ groupedByOpportunity, loading }" class="elevation-2">
          <v-card
            v-for="(feedbackRequests, i) in groupedByOpportunity"
            :key="i"
            class="transparent"
            flat
          >
            <OpportunityData :id="parseInt(i)">
              <v-toolbar
                slot-scope="{ opportunity }"
                color="white"
                height="80"
                flat
              >
                <div v-if="opportunity && opportunity.name">
                  <div class="headline text-xs-center">
                    {{ opportunity.name }}
                  </div>
                  <div
                    class="subheading text-xs-center"
                    v-if="opportunity.organization"
                  >
                    <span v-if="opportunity.organization.name">
                      {{ opportunity.organization.name }}
                    </span>
                  </div>
                </div>
              </v-toolbar>
            </OpportunityData>
            <v-divider />
            <div
              v-for="(feedbackRequest, j) in feedbackRequests"
              :key="`feedback-${j}`"
            >
              <FeedbackCard
                :feedbackRequest="feedbackRequest"
                @click="view = feedbackRequest.id"
              />
              <v-divider v-if="j < feedbackRequests.length - 1" />
            </div>
          </v-card>

          <v-card v-if="!loading && !Object.keys(groupedByOpportunity).length">
            <div class="text-xs-center pt-3">
              <v-icon size="100">mdi-clipboard-outline</v-icon>
            </div>
            <v-card-text class="text-xs-center subtitle">
              No candidates have been shared with you yet
            </v-card-text>
          </v-card>
        </div>
      </FeedbackRequestsListData>

      <FeedbackRequestDialog
        v-if="ready && view"
        :id="parseInt(view)"
        @close="view = null"
      />
    </v-container>
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from "@/mixins/managedDocumentAttributes";

// Components
import FeedbackCard from "@/components/client/feedback_requests/FeedbackCard";
import FeedbackRequestDialog from "@/components/client/feedback_requests/FeedbackRequestDialog";
import FeedbackRequestsListData from "@/components/client/feedback_requests/FeedbackRequestsListData";
// Using guest component, responders usually don't have permission to view opportunities
import OpportunityData from "@/components/guest/opportunities/OpportunityData";

export default {
  mixins: [managedDocumentAttributes],

  name: "FeedbackRequests",

  components: {
    FeedbackCard,
    FeedbackRequestDialog,
    FeedbackRequestsListData,
    OpportunityData
  },

  created() {
    this.$store.dispatch("client/organization/fetch").then(() => {
      this.documentAttributes.title = `Shared Profiles – ${this.organization.name} – Leaply`;
    });
  },

  data() {
    return {
      // Toggles
      loading: { feedbackRequests: true },
      view: null
    };
  },

  computed: {
    ready() {
      return !Object.keys(this.loading).every(key => !this.loading[key]);
    },

    user() {
      return this.$store.getters["auth/user"];
    },

    organization() {
      return this.$store.getters["client/organization/model"];
    }
  }
};
</script>

<style lang="scss">
.client.feedback-requests.page {
  div.v-toolbar__content {
    justify-content: center;
  }
}
</style>
<!-- .client.ats.page div.overlay { -->
<!-- position: relative; -->
<!-- } -->

<!-- .client.ats.page div.overlay:after { -->
<!-- position: absolute; -->
<!-- content: ''; -->
<!-- top: 0; -->
<!-- left: 0; -->
<!-- width: 100%; -->
<!-- height: 100%; -->
<!-- background-color: rgba(0, 0, 0, 0.3); -->
<!-- z-index: 200; -->
<!-- } -->

<!-- .client.ats.page div.v-toolbar__extension, -->
<!-- .client.ats.page div.v-toolbar__extension .v-tabs__item { -->
<!-- padding-left: 0; -->
<!-- padding-right: 0; -->
<!-- } -->

<!-- .client.ats.page .client.ats.phase.tabs .ats-tabs { -->
<!-- max-width: 100%; -->
<!-- overflow-x: scroll; -->
<!-- cursor: pointer; -->
<!-- scroll-behavior: smooth; -->
<!-- } -->
<!-- .client.ats.page .client.ats.phase.tabs .bottom-border { -->
<!-- position: absolute; -->
<!-- width: 100%; -->
<!-- height: 0.5rem; -->
<!-- bottom: 0px; -->
<!-- } -->

<!-- .client.ats.page .client.ats.phase.tabs .phase-card { -->
<!-- background-color: rgba(0, 0, 0, 0); -->
<!-- border: 0px; -->
<!-- } -->

<!-- .client.ats.page .client.ats.phase.tabs .phase-card:hover, -->
<!-- .client.ats.page .client.ats.phase.tabs .phase-card--active { -->
<!-- background-color: rgba(0, 0, 0, 0.2); -->
<!-- } -->

<!-- .client.ats.page .client.ats.phase.tabs .scroll-button { -->
<!-- position: absolute; -->
<!-- top: 50%; -->
<!-- } -->
<!-- .client.ats.page .client.ats.phase.tabs .scroll-button.left { -->
<!-- left: 0px; -->
<!-- transform: translate(-50%, -50%); -->
<!-- } -->
<!-- .client.ats.page .client.ats.phase.tabs .scroll-button.right { -->
<!-- right: 0px; -->
<!-- transform: translate(50%, -50%); -->
<!-- } -->

<!-- .client.ats.page .client.ats.phase.tabs .v-tabs__wrapper--show-arrows { -->
<!-- margin-right: 0px; -->
<!-- margin-left: 0px; -->
<!-- } -->

<!-- .client.ats.page .client.ats.phase.tabs .v-badge__badge { -->
<!-- width: 100%; -->
<!-- border-radius: 20px; -->
<!-- } -->
